import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/lenis";

const NAV = [
  { label: "Production", id: "#production" },
  { label: "Stories", id: "#stories" },
  { label: "Writing Room", id: "#writing-room" },
  { label: "Contact", id: "#contact" },
];

export default function GoshtaFooter() {
  return (
    <footer data-testid="goshta-footer" className="relative border-t border-white/10 bg-[#0a0a0a]">
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 md:px-10 md:pt-28">
        <button
          data-testid="goshta-footer-brand"
          onClick={() => scrollToId("#top")}
          className="group block text-left"
        >
          <span className="flex items-center gap-5">
            <img
              src="/assets/goshta-mark.png"
              alt="Goshta logo mark"
              className="h-16 w-16 rounded-full border border-[#B79045]/40 object-cover transition-transform duration-700 group-hover:rotate-[20deg] md:h-20 md:w-20"
            />
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
              The Writer Room Productions
            </span>
          </span>
          <span className="mt-4 block font-display text-[16vw] font-medium leading-none tracking-tight text-neutral-100 transition-colors duration-500 group-hover:text-[#D4AF37] sm:text-[11vw] lg:text-[8vw]">
            GOSHTA<em className="italic text-[#B79045]">.</em>
          </span>
        </button>

        <p className="mt-8 max-w-xl text-sm leading-relaxed text-neutral-400">
          Complete line production services and story development—from the first thought to
          screenplay and dialogue.
        </p>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    data-testid={`goshta-footer-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => scrollToId(n.id)}
                    className="text-sm text-neutral-300 transition-colors duration-300 hover:text-[#D4AF37]"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Contact</p>
            <ul className="mt-5 space-y-3 text-sm text-neutral-300">
              <li>
                <a
                  data-testid="goshta-footer-email"
                  href="mailto:suyog@veritasadvisory.co.in"
                  className="transition-colors duration-300 hover:text-[#D4AF37]"
                >
                  suyog@veritasadvisory.co.in
                </a>
              </li>
              <li>
                <a
                  data-testid="goshta-footer-whatsapp"
                  href="https://wa.me/918850845977"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors duration-300 hover:text-[#D4AF37]"
                >
                  WhatsApp: +91 88508 45977
                </a>
              </li>
            </ul>
          </div>
          <div className="flex flex-col items-start justify-between gap-8">
            <Link
              data-testid="goshta-footer-veritas-link"
              to="/veritas"
              className="group flex items-center gap-4 border border-white/10 p-4 transition-colors duration-300 hover:border-[#B79045]/50"
            >
              <img
                src="/assets/veritas-seal-192.png"
                alt="Veritas Advisory LLP seal"
                className="h-12 w-12 rounded-full border border-[#B79045]/40 object-cover transition-transform duration-700 group-hover:rotate-45"
              />
              <span className="flex flex-col">
                <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500">
                  A venture of
                </span>
                <span className="font-display text-base text-neutral-200 transition-colors duration-300 group-hover:text-[#D4AF37]">
                  Veritas Advisory LLP
                </span>
              </span>
            </Link>
            <button
              data-testid="goshta-footer-top"
              onClick={() => scrollToId("#top")}
              aria-label="Back to top"
              className="flex h-11 w-11 items-center justify-center border border-white/15 text-neutral-400 transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 md:flex-row md:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
            © 2026 Goshta — The Writer Room Productions. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              data-testid="goshta-footer-veritas-text-link"
              to="/veritas"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600 transition-colors duration-300 hover:text-[#D4AF37]"
            >
              Veritas Advisory
            </Link>
            <Link
              data-testid="goshta-footer-admin-link"
              to="/admin"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600 transition-colors duration-300 hover:text-[#D4AF37]"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
